// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./btn_join_wb.png");
var dir = previousRequest.replace("btn_join_wb.png", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "btn_join_wb.png",
	name: "btn_join_wb",
	ext: ".png",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/btn_join_wb.png
// module id = 1028
// module chunks = 4